import React from 'react';
import { Box, Text, TextProps } from '@chakra-ui/react';
import { DataTestId } from 'types/general.types';
import clsx from 'clsx';

export interface ListItemTextProps extends DataTestId {
  primary?: string | React.ReactElement;
  secondary?: string | React.ReactElement;
  primaryTextProps?: TextProps;
  secondaryTextProps?: TextProps & DataTestId;
  title?: string;
  className?: string;
}

export const ListItemText: React.FC<ListItemTextProps> = ({
  primary,
  primaryTextProps,
  secondaryTextProps,
  secondary,
  className,
  title,
  'data-testid': dataTestId,
}) => {
  if (primary && secondary) {
    return (
      <Text
        className={className}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        letterSpacing="0.5px"
        as={Box}
      >
        <Text
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
          letterSpacing="0.5px"
          data-testid={dataTestId}
          title={title}
          {...primaryTextProps}
          as={typeof primary === 'string' ? 'p' : Box}
        >
          {primary}
        </Text>
        {typeof secondary === 'string' ? (
          <Text
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            overflow="hidden"
            letterSpacing="0.5px"
            {...secondaryTextProps}
          >
            {secondary}
          </Text>
        ) : (
          secondary
        )}
      </Text>
    );
  }

  return (
    <Text
      data-testid={dataTestId}
      textOverflow="ellipsis"
      whiteSpace="nowrap"
      overflow="hidden"
      letterSpacing="0.5px"
      title={title}
      as={typeof primary === 'string' ? 'p' : Box}
      {...primaryTextProps}
      className={clsx(className, primaryTextProps?.className)}
    >
      {primary}
    </Text>
  );
};
